import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'moduleFilter',
  pure: true // This pipe is pure so it only runs when its inputs change
})
export class ModuleFilterPipe implements PipeTransform {
  transform(modules: any[], searchTerm: string): any[] {
    if (!modules || !searchTerm) {
      return modules;
    }

    const lowerSearchTerm = searchTerm.toLowerCase();
    return modules
      .map(module => {
        const filteredChildren = module.children
          ? this.transform(module.children, lowerSearchTerm)
          : [];
        // Include the module if its name matches or any child matches
        if (module.name.toLowerCase().includes(lowerSearchTerm) || (filteredChildren && filteredChildren.length)) {
          return { ...module, children: filteredChildren };
        }
        return null;
      })
      .filter(module => module !== null) as any[];
  }
}
